import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CALENDAR_LOCALE } from '../../services/constant';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
var ImportDataComponent = (function () {
    function ImportDataComponent(apiService, authService, modelService, translate, modalService) {
        this.apiService = apiService;
        this.authService = authService;
        this.modelService = modelService;
        this.translate = translate;
        this.modalService = modalService;
        this.itemsPerPage = 40;
        this.startDate = null;
        this.endDate = null;
        this.totalItems = 0;
        this.selectedValues = [];
        this.currentPage = 1;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.loading = false;
        this.tableData = [];
        this.disable = false;
    }
    ImportDataComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
        this.loadTexts();
        this.loadData();
    };
    ImportDataComponent.prototype.loadTexts = function () {
        var _this = this;
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.statusData = [
            { label: this.translate.instant('COMMON.ALL'), value: null },
            { label: this.translate.instant('TEXT.SUCCESS'), value: 'success' },
            { label: this.translate.instant('TEXT.FAILED'), value: 'failed' }
        ];
        this.importMethod = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getAllImportMethods().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.importMethod.push({
                    label: obj,
                    value: obj
                });
            });
            _this.importMethod = _.uniqBy(_this.importMethod, 'label');
        }, function (error) { return error(status); });
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
    };
    ImportDataComponent.prototype.resolveError = function ($event, popup, data) {
        this.modalData = data;
        this.disable = false;
        this.modal = this.modalService.open(popup, { backdrop: 'static', keyboard: false, centered: true });
    };
    ImportDataComponent.prototype.revertBack = function () {
        this.modal.close();
    };
    Object.defineProperty(ImportDataComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImportDataComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    ImportDataComponent.prototype.pageChanged = function () {
        // const params = new HttpParams().set('page', _.toString(this.currentPage));
        this.loadData();
    };
    ImportDataComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    ImportDataComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    ImportDataComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    ImportDataComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = '';
        }
        else {
            this.sortMode = '-';
        }
    };
    ImportDataComponent.prototype.clearSearch = function () {
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.selectedStatus = null;
        this.selectedMethod = null;
        this.documentNumber = null;
        this.startDate = null;
        this.endDate = new Date();
        this.startDate = new Date();
        this.sortBy = null;
        this.sortMode = null;
        this.totalItems = null;
        this.disable = false;
        this.modal = null;
        this.loadTexts();
        this.loadData();
    };
    ImportDataComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.loadData();
    };
    ImportDataComponent.prototype.downloadCsvOrPdfFile = function (fileName, url) {
        var _this = this;
        var mediaUrl = url.split('media/')[1];
        var ext = mediaUrl.slice(-3);
        this.apiService.downloadFileFromMediaPath(mediaUrl).subscribe(function (obj) {
            _this.apiService.createDownloadFile(obj, fileName);
            if (ext === 'csv') {
                _this.sniff('DOWNLOAD_ORI_CSV', fileName);
            }
            else {
                _this.sniff('DOWNLOAD_ORI_PDF', fileName);
            }
        }, function (error) {
        });
    };
    ImportDataComponent.prototype.downloadJsonFile = function (json) {
        var blob = new Blob([JSON.stringify(json, null, 2)], { type: 'application/json' });
        var issueDtOnlyDate = json.data.header.issue_dt.slice(0, 10).replace(/-/g, '_');
        var fileName = json.data.header.invoice_number + '_' + json.file_type + '_' + issueDtOnlyDate + '.json';
        this.apiService.createDownloadFile(blob, fileName);
        this.sniff('DOWNLOAD_ORI_JSON', fileName);
    };
    ImportDataComponent.prototype.loadData = function (param) {
        var _this = this;
        this.tableData = [];
        var startDates = moment(this.startDate).format('YYYY-MM-DD');
        var endDates = moment(this.endDate).format('YYYY-MM-DD');
        var params = new HttpParams();
        if (this.startDate) {
            params = params.append('header_issue_date_start', startDates);
            params = params.append('header_issue_date_end', endDates);
        }
        if (this.sortBy) {
            params = params.append('ordering', this.sortMode + this.sortBy);
        }
        params = params.append('page', this.currentPage.toString());
        params = params.append('items_per_page', this.itemsPerPage.toString());
        if (this.selectedStatus) {
            params = params.append('status', this.selectedStatus);
        }
        if (this.selectedMethod) {
            params = params.append('method', this.selectedMethod);
        }
        if (this.documentNumber) {
            params = params.append('invoice_number', this.documentNumber);
        }
        this.loading = true;
        this.apiService.getErrors(params).subscribe(function (data) {
            _.forEach(data.results, function (obj) {
                _this.tableData.push({
                    'created_at': obj.created_at,
                    'method': obj.method,
                    'status_display': obj.status === 'doing' ? 'DASHBOARD.PROCESSING' : 'DASHBOARD.' + obj.status.toUpperCase(),
                    'json': obj.json,
                    'csv_name': obj.tax_import === null ? '-' : obj.tax_import.csv_name,
                    'csv_file': obj.tax_import === null ? '-' : obj.tax_import.csv_file,
                    'pdf_name': obj.tax_import === null || obj.tax_import.pdf_name === null ? '-' : obj.tax_import.pdf_name,
                    'pdf_file': obj.tax_import === null || obj.tax_import_pdf_file === null ? '-' : obj.tax_import.pdf_file,
                    'invoice_number': obj.invoice_number,
                    'detail': obj.detail === null || obj.detail.message === null ? '-' : obj.detail.message,
                    'row': obj.detail === null || obj.detail.row === null ? '-' : obj.detail.row
                });
            });
            _this.totalItems = data.count;
            _this.loading = false;
        });
    };
    ImportDataComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'IMPORT_DATA',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    ImportDataComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return ImportDataComponent;
}());
export { ImportDataComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data.component.ts.pre-build-optimizer.js